<template>
  <div class="intercept-warehousing">
    <div class="search">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <div class="search-row">
          <el-form-item label="货主：" prop="customerId">
            <el-select v-model="ruleForm.customerId" class="gray white" placeholder="请选择货主" clearable>
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：" prop="orderCode">
            <el-input
              class="gray white"
              v-model="ruleForm.orderCode"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="下单时间：" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="——"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="search-row">
          <el-form-item label="状态：" prop="status">
            <el-select v-model="ruleForm.status" class="gray white" placeholder="请选择状态" clearable>
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-blue" @click="searchData">搜索</el-button>
            <el-button @click="clear('ruleForm')">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 1"
              class="btn-text"
              type="text"
              @click="intercept(scope.row.id)"
            >拦截</el-button>
            <el-button
              v-if="scope.row.status === 3"
              class="btn-text"
              type="text"
              @click="Warehousing(scope.row.id)"
            >入库</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Intercept from "models/intercept";
import Logistics from "models/logistics";
const logistics = new Logistics();
import { formaTimeToMinute } from "common/js/util";
const STATUS = {1:'待拦截', 2:'已拦截',3:'已制单',4:'已入库'}
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '下单时间', prop: 'orderCreateTime', width: '130'},
        {label: '订单号', prop: 'systemOrderNo', width: '120'},
        {label: '货主', prop: 'customerName', width: '120'},
        {label: '运单号', prop: 'expressNo', width: '120'},
        {label: '承运商', prop: 'carrier', width: '120'},
        {label: '外部单号', prop: 'externalOrderNo', width: '200'},
        {label: '商品信息', prop: 'skuInfo', width: '240'},
        {label: '商品数量', prop: 'skuQuantity', width: '100'},
        {label: '拦截时间', prop: 'interceptTime', width: '130'},
        {label: '状态', prop: 'statusVal', width: '120'},
      ],
      customerList: [],
      statusList: [
        {id:1, name: '待拦截'},
        {id:2, name: '已拦截'},
        {id:3, name: '已制单'},
        {id:4, name: '已入库'},
      ],
      ruleForm: {
        customerId: '',
        orderCode: '',
        date: '',
        status: ''
      },
    };
  },

  created() {
    this.initInterceptWarehousing();
    this.initCustomerList()
  },

  methods: {
    clear(formName) {
      this.$refs[formName].resetFields();
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initInterceptWarehousing();
    },
    initInterceptWarehousing() {
      let pageNo = this.currentPage
      let customerId = this.ruleForm.customerId
      let code = this.ruleForm.orderCode
      let beginDate = this.ruleForm.date[0]?this.ruleForm.date[0]:''
      let endDate = this.ruleForm.date[1]?this.ruleForm.date[1]:''
      let status = this.ruleForm.status
      Intercept.getInterceptWarehouseList(pageNo,customerId,code,beginDate,endDate,status).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.customerId = i.customerId
            obj.customerName = i.customerName
            obj.orderCreateTime = formaTimeToMinute(i.orderCreateTime)
            if (i.interceptTime) {
              obj.interceptTime = formaTimeToMinute(i.interceptTime)
            } else {
              obj.interceptTime = ''
            }
            obj.skuInfo = i.skuInfo
            obj.skuQuantity = i.skuQuantity
            obj.systemOrderNo = i.systemOrderNo
            obj.expressNo = i.expressNo
            obj.externalOrderNo = i.externalOrderNo
            obj.carrier = i.carrier
            obj.status = i.status
            obj.statusVal = STATUS[i.status]
            obj.warehouseId = i.warehouseId
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 获取货主名称 */
    initCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    searchData() {
      this.currentPage = 1;
      this.initInterceptWarehousing();
    },
    /* 拦截 */
    intercept(id) {
      this.$confirm("确认对此订单拦截？", "拦截", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      })
        .then(() => {
          let data = {
            id
          }
          Intercept.postIntercept(data).then(res => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "拦截成功!"
              });
              this.initInterceptWarehousing();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /* 入库 */
    Warehousing(id) {
      this.$confirm("确认此订单已经入库？", "入库", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "messageBox",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-white",
      })
        .then(() => {
          let data = {
            id
          }
          Intercept.postInstock(data).then(res => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "入库成功!"
              });
              this.initInterceptWarehousing();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  },
};
</script>

<style lang='scss' scoped>
.intercept-warehousing {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .search-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .el-select {
      width: 200px;
      margin-right: 16px;
    }
    .el-input {
      width: 200px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.intercept-warehousing {
  .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .el-dialog__body {
      display: flex;
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
